import { getAccountDetails } from 'actions/accountActions';
import AppPageHeader from 'components/common/AppPageHeader';
import PageContainer from 'components/common/PageContainer';
import PageRow from 'components/common/PageRow';
import { PENDING_USER_STATUS } from 'constants/userStatuses';
import getSymbolFromCurrency from 'currency-symbol-map';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { colors } from 'styles/shared';
import ApiSection from './components/ApiSection';
import Banner from './components/Banner';
import DocsSection from './components/DocsSection';
import InfoSection from './components/InfoSection';
import PlanSection from './components/PlanSection';





function HomePage() {
  const dispatch = useDispatch();

  const user = useSelector((state: any) => state.user.current);

  const [apiKey, setApiKey] = useState('');
  const [trial, setTrial] = useState(false);
  const [keyCount, setKeyCount] = useState(0);
  const [plan, setPlan] = useState<any>({});

  const [totalRequestsNumber, setTotalRequestsNumber] = useState('0');
  const [amount, setAmount] = useState(0);
  const [currencySymbol, setCurrencySymbol] = useState('');

  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function initData() {
    const userId = user?.id;

    if (!userId) return;

    let accountDetails: any = await dispatch(getAccountDetails(userId));

    if (!accountDetails) return;

    if (accountDetails.amount) setAmount(accountDetails.amount);
    if (accountDetails.requests) setTotalRequestsNumber(accountDetails.requests.toString());
    if (accountDetails.currency) {
      let symbol = getSymbolFromCurrency(accountDetails.currency);
      if (symbol) setCurrencySymbol(symbol);
    }

    if (accountDetails.plan && accountDetails.plan.name !== '') setPlan(accountDetails.plan);

    let userKeys = accountDetails?.api_keys?.filter(key => key.user_id === userId);

    if (!userKeys) return;

    let firstKey = userKeys[0];

    if (!firstKey) return;

    setApiKey(firstKey.id || '');
    setTrial(firstKey.trial || false);
    setKeyCount(userKeys.length);
    
    if (firstKey.trial === true) {
      setTotalRequestsNumber(accountDetails.remaining.toString());
    } else {
      setTotalRequestsNumber(accountDetails.requests.toString());
    }
    
  }

  function isUserSubscribed() {
    let subscribed = user.subscription_id !== null && user.subscription_id !== '' && plan;
    return subscribed ? true : false;
  }

  function isPendingUser() {
    return user?.status === PENDING_USER_STATUS;
  }

  function render() {
    let billingAmount = `${currencySymbol}${amount}`;

    const subscribed = isUserSubscribed();

    const pending = isPendingUser();

    return (
      <PageContainer>
        <AppPageHeader title="Home" />

        {!subscribed && <Banner pending={pending} />}

        <PageRow>
          <ApiSection apiKey={apiKey} trial={trial} requests={keyCount} />

          <InfoSection
            title={trial ? "Trial requests remaining" : "Requests"}
            amount={totalRequestsNumber}
            iconName="requests"
            iconBackground={colors.blue_light}
          />

          <InfoSection
            title="This month"
            amount={billingAmount}
            iconName="billing"
            iconBackground={colors.green_lighter}
            iconColor={colors.green_main}
          />
        </PageRow>

        <PageRow>
          <DocsSection />
          <PlanSection subscribed={subscribed} pending={pending} planName={plan?.name} />
        </PageRow>
      </PageContainer>
    );
  }

  return render();
}

export default HomePage;
